import * as React from 'react';
import { Tags } from '@leapfinance/geebee-component-library';
import { convertToReadable } from '../../helpers';
// const getChipStyles: (conditionLabel: string) => string = (conditionLabel) => {
//   const chipVariant = conditionChipVariantMapper;
//   if (chipVariant === 'warning') {
//     return 'lfc-bg-[#FCECDD] lfc-text-[#B26116] lfc-border lfc-border-[#B26116]';
//   }
//   if (chipVariant === 'success') {
//     return 'lfc-bg-success-100 lfc-text-success-600 lfc-border lfc-border-success-600';
//   }
//   if (chipVariant === 'error') {
//     return 'lfc-bg-error-100 lfc-text-error-600 lfc-border lfc-border-error-600';
//   }
//   return '';
// };
var conditionChipVariantMapper = {
    CONDITION_MET: 'warning',
    CONDITION_NOT_MET: 'warning',
    CONDITION_ON_HOLD: 'error',
    FOLLOW_UP_DONE: 'success',
    CONDITION_VERIFIED: 'success'
};
var ConditionStatusDisplayChip = function (_a) {
    var labelText = _a.labelText;
    if (!labelText) {
        return null;
    }
    return (React.createElement(Tags, { title: convertToReadable(labelText), variant: conditionChipVariantMapper[labelText], size: "medium", hasActiveBorder: true }));
    // return (
    //   <div>
    //     <Typography variant="body2" className={`lfc-px-2 lfc-py-1 lfc-rounded-[32px] ${getChipStyles(labelText)}`}>
    //       {convertToReadable(labelText)}
    //     </Typography>
    //   </div>
    // );
};
export default ConditionStatusDisplayChip;
//# sourceMappingURL=ConditionStatusDisplayChip.js.map